import { render, staticRenderFns } from "./addChuYouRen.vue?vue&type=template&id=251b3a60&scoped=true&"
import script from "./addChuYouRen.vue?vue&type=script&lang=js&"
export * from "./addChuYouRen.vue?vue&type=script&lang=js&"
import style0 from "./addChuYouRen.vue?vue&type=style&index=0&id=251b3a60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "251b3a60",
  null
  
)

export default component.exports